<template>
  <div>
    <Layout :pagetitle="$t('Affiliates')">
      <div class="card">
        <div class="card-header">
          <div>
            <b-row>
              <b-col md="6">
                <h4 class="card-title" v-html="$t('Actions')" />
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="card-body">
          <div>
            <b-row>
              <div class="col-md-3">
                <span>
                  <label>{{ $t('Search') }}</label>
                  <b-form-input v-model="search" type="text" id="search-table-input" :placeholder="$t('Search')" />
                </span>
              </div>
              <div class="col-md-3">
                <span>
                  <label>{{ $t('Sub Brand') }}</label>
                  <subBrandsSelector :mode="'single'" :modelValue="idSubBrand" @onChange="setSubBrand" />
                </span>
              </div>
              <div class="col-md-3" />
              <div class="col-md-3">
                <div class="d-flex justify-content-end">
                  <label>&nbsp;</label>
                  <div class="table-buttons mt-4 pt-1">
                    <button @click="createAction" class="btn btn-primary">
                      {{ $t('Create') }}
                    </button>
                    <button @click="exportXls" class="btn btn-success ml-1">
                      {{ $t('XLS') }}
                    </button>
                  </div>
                </div>
              </div>
            </b-row>
            <b-row>
              <b-col>
                <Table
                  :isCard="false"
                  :title="''"
                  :items="actions"
                  :columns="columns"
                  :totalItems="totalItems"
                  :showButtons="true"
                  :searchable="false"
                  :editable="true"
                  :removable="true"
                  :showPagination="true"
                  @onSearch="onSearch"
                  @onEdit="editAction"
                  @onCreate="createAction"
                  @onRemove="onRemove"
                  @onChangePage="changePage"
                  :customActionBtn="true"
                  @customAction="showQrCode"
                  customActionName="QR Code"
                  :exportXls="true"
                  @buttonXls="exportXls"
                />
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </Layout>
    <b-modal v-model="showModal" title="QR Code" ok-only>
      <template #default>
        <modalActionQrCode :name="name" :token="token" :urlAdvertising="urlAdvertising" />
      </template>
    </b-modal>
  </div>
</template>
<script>
import Layout from '@/views/layouts/main';
import modalActionQrCode from './components/modalActionQrCode';
import subBrandsSelector from '@/components/selectors/subBrandsSelector';
import Table from '@/components/bootstrap/table';
import { exportXls } from './functions';

export default {
  components: { Layout, Table, modalActionQrCode, subBrandsSelector },
  data() {
    return {
      search: '',
      page: 1,
      totalItems: 0,
      actions: [],
      name: '',
      token: '',
      urlAdvertising: '',
      showModal: false,
      idSubBrand: null
    };
  },
  mounted() {
    this.getActions();
    this.enableSearch();
  },
  methods: {
    setSubBrand(id = null) {
      this.idSubBrand = id;
      this.onSearch(this.search);
    },
    exportXls() {
      this.$store.commit('SET_LOADING', true);
      this.$api
        .get(`api/action/all`)
        .then((res) => {
          this.$store.commit('SET_LOADING', false);

          let data = res.data.map((a) => {
            return {
              ...a,
              url: `${a.brand_settings?.urlAdvertising}${a.action_token}`,
              affiliate_document: a.affiliate_settings?.document?.value || null,
              affiliate_document_type: a.affiliate_settings?.document?.type || null,
              payment_type: a?.affiliate_payment_type || null
            };
          });

          exportXls({
            items: data,
            columns: [
              ...this.columns,
              {
                key: 'action_token',
                label: `Token (${this.$t('Action')})`
              },
              {
                key: 'payment_type',
                label: this.$t('Payment Type')
              }
            ]
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    showQrCode(action) {
      this.$store.commit('SET_LOADING', true);
      this.$api
        .get(`api/action/${action.id}`)
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          this.name = action.name;
          this.token = res.data?.affiliate?.token || '';
          this.urlAdvertising = res.data?.brand?.settings?.urlAdvertising || '';
          this.urlAdvertising += action.token;
          this.showModal = true;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    changePage(page) {
      this.page = page;
      this.getActions();
    },
    onRemove(action) {
      this.$api.destroy(`api/action/${action.id}`).then(() => {
        this.$customAlert({
          type: 'success',
          msg: this.$t('Action was excluded with success')
        });
        this.getActions();
      });
    },
    getActions() {
      this.$store.commit('SET_LOADING', true);

      let queryParams = { search: this.search, page: this.page };

      if (this.idSubBrand) {
        queryParams['idSubBrand'] = this.idSubBrand;
      }

      this.$api
        .get('api/action', queryParams)
        .then((res) => {
          this.page = 1;
          this.$store.commit('SET_LOADING', false);
          this.actions = res.data?.results || [];
          this.actions = this.actions.map((a) => {
            return {
              ...a,
              url: `${a.campaign?.brand?.settings?.urlAdvertising}${a.token}`,
              affiliate_document: a.affiliate?.settings?.document?.value || null,
              affiliate_document_type: a.affiliate?.settings?.document?.type || null
            };
          });
          this.totalItems = res.data.total;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    createAction() {
      this.$router.push({
        name: 'actionCreate'
      });
    },
    editAction(action) {
      this.$router.push({
        name: 'actionUpdate',
        params: {
          id: action.id
        }
      });
    },
    onSearch(search = '') {
      this.search = search;
      this.getActions();
    },
    enableSearch() {
      let input_search = document.getElementById('search-table-input');
      input_search.addEventListener(
        'keyup',
        this.$utils.debounce(() => {
          this.onSearch(this.search);
        })
      );
    }
  },
  computed: {
    columns() {
      let cols = [
        {
          key: 'campaign_name',
          label: this.$t('Campaign')
        },
        {
          key: 'affiliate_name',
          label: this.$t('Affiliate')
        },
        {
          key: 'affiliate_token',
          label: this.$t('Token')
        },
        {
          key: 'affiliate_document',
          label: this.$t('Document')
        },
        {
          key: 'affiliate_document_type',
          label: this.$t('Document type')
        },
        {
          key: 'sub_brand_name',
          label: this.$t('Sub Brand')
        },
        {
          key: 'name',
          label: this.$t('Name')
        },
        {
          key: 'utm_medium',
          label: 'UTM Medium'
        },
        {
          key: 'utm_content',
          label: 'UTM Content'
        },
        {
          key: 'url',
          label: 'URL'
        }
      ];
      return cols;
    }
  }
};
</script>

<style></style>
